import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

function trim(value: unknown): string {
  return value === null || value === undefined ? '' : String(value).trim();
}

function buildLocalAddress(parts: {
  blockNo?: unknown;
  streetName?: unknown;
  buildingName?: unknown;
  level?: unknown;
  unit?: unknown;
  postalCode?: unknown;
}): string {
  const blockNo = trim(parts.blockNo);
  const streetName = trim(parts.streetName);
  const buildingName = trim(parts.buildingName);
  const level = trim(parts.level);
  const unit = trim(parts.unit);
  const postalCode = trim(parts.postalCode);
  const line1 = [blockNo, streetName].filter(Boolean).join(' ').trim();
  const line2 = level || unit ? `#${[level, unit].filter(Boolean).join('-')}` : '';
  return [line1, line2, buildingName, postalCode ? `SINGAPORE ${postalCode}` : ''].filter(Boolean).join(', ');
}

function buildForeignAddress(line1: unknown, line2: unknown): string {
  return [trim(line1), trim(line2)].filter(Boolean).join(', ');
}

function formatResidentialAddress(raw: any): string {
  if (typeof raw === 'string') return trim(raw);
  const contact = raw && typeof raw === 'object' ? raw : {};
  const local = buildLocalAddress({
    blockNo: contact.blockNo,
    streetName: contact.streetName,
    buildingName: contact.buildingName,
    level: contact.addrLevel,
    unit: contact.addrUnit,
    postalCode: contact.postalCode,
  });
  return local || buildForeignAddress(contact.foreignAddressLine1, contact.foreignAddressLine2);
}

function formatServiceAddress(raw: any): string {
  if (typeof raw === 'string') return trim(raw);
  const contact = raw && typeof raw === 'object' ? raw : {};
  const local = buildLocalAddress({
    blockNo: contact.altBlockNo,
    streetName: contact.altStreetName,
    buildingName: contact.altBuildingName,
    level: contact.altAddrLevel,
    unit: contact.altAddrUnit,
    postalCode: contact.altPostalCode,
  });
  return local || buildForeignAddress(contact.altForeignAddressLine1, contact.altForeignAddressLine2);
}

/** Appoint Secretary(B32103) 등록 모달과 동일 필드 + Cessation date (회사 주소/회사명 등 제외) */
const withdrawSecretaryDetailMap = {
  title: 'Withdraw Secretary',
  fields: [
    {
      label: 'Full Name',
      key: ['secretaryName', 'secretary_name', 'directorName', 'officerName', 'contactData.contactName'],
    },
    {
      label: 'NRIC / FIN / Passport No',
      key: [
        'secretaryIdentificationNo',
        'secretary_identification_no',
        'directorIdentificationNo',
        'contactData.contactRegNo',
      ],
    },
    {
      label: 'Date of Birth',
      key: ['secretaryDateOfBirth', 'directorDateOfBirth', 'contactData.dateOfBirth'],
    },
    {
      label: 'Nationality',
      key: ['secretaryNationality', 'directorNationality', 'contactData.nationalityText'],
    },
    { label: 'Email', key: ['secretaryEmail', 'directorEmail', 'contactData.contactEmail'] },
    { label: 'Contact No', key: ['secretaryContactNo', 'directorContactNo', 'contactData.mobileNo'] },
    {
      label: 'Date of Appointment',
      key: [
        'appointmentEffectiveDate',
        'appointmentDate',
        'appointedDate',
        'dateOfAppointment',
        'dateOfAppointed',
        'contactData.dateOfAppointment',
        'formData.appointedDate',
        'formData.appointmentDate',
        'officerData.appointedDate',
        'officerData.appointmentDate',
      ],
    },
    {
      label: 'Cessation date',
      key: [
        'cessationDate',
        'dateOfCessation',
        'resignationDate',
        'resignation_date',
        'formData.cessationDate',
        'formData.dateOfCessation',
        'officerData.cessationDate',
        'officerData.dateOfCessation',
      ],
    },
    {
      label: 'Reason for cessation',
      key: ['reasonForCessation', 'reason_for_cessation', 'formData.reasonForCessation'],
    },
    {
      label: 'Other reason',
      key: ['otherReasonForCessation', 'other_reason_for_cessation', 'otherReason', 'formData.otherReasonForCessation'],
    },
    {
      label: 'Residential Address',
      key: ['secretaryAddress', 'directorAddress', 'primaryAddress', 'contactData'],
      format: formatResidentialAddress,
    },
    {
      label: 'Contact Address',
      key: ['secretaryAlternateAddress', 'directorAlternateAddress', 'serviceAddress', 'contactData'],
      format: formatServiceAddress,
    },
  ],
};

registerRegisterDetail('B32104', withdrawSecretaryDetailMap);
